import { render, staticRenderFns } from "./VoiceMessage.vue?vue&type=template&id=0cab9c36&scoped=true&"
import script from "./VoiceMessage.vue?vue&type=script&lang=js&"
export * from "./VoiceMessage.vue?vue&type=script&lang=js&"
import style0 from "./VoiceMessage.vue?vue&type=style&index=0&id=0cab9c36&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cab9c36",
  null
  
)

export default component.exports